import { Shark, Utils, View } from "shark-mvc";

import templateContent from "./contact-manage.html";

import { clientManager } from "../../_shark_jaws/managers/clientManager";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { userManager } from "../../_shark_jaws/managers/userManager";
import { informationModalComponent } from "../../components/informationModal/informationModalComponent";
import { quotationItemModal } from "../../_shark_jaws/components/quotationItemModalComponent";
import { visitManager } from "../../_shark_jaws/managers/visitManager";

class ContactManageView extends View {
	constructor() {
		super("contactManageView");

		this.setTemplate(templateContent);
	}

	beforeLoad () {
		window.scrollTo(0, 0);

		if (!Shark.get("agentList")) {
			userManager.getList()
			.then(() => Shark.render());
		}
	}

	confirmProspectBranchReassignBtn_clickHandler () {
		const reassignProspectBranchToLeadSettings = Shark.get("reassignProspectBranchToLeadSettings");

		console.log({reassignProspectBranchToLeadSettings})

		if (confirm(`Sei sicuro di voler unificare tutto il "ramo" del Report '${reassignProspectBranchToLeadSettings.contactName}' al Lead '${reassignProspectBranchToLeadSettings.leadName}'?\n\nNon sarà possibile annullare!!`)) {
			clientManager.reassignProspectBranchToLead(reassignProspectBranchToLeadSettings)
			.then(response => {
				console.log({response});
				alert("Operazione completata");
			});
		}
	}

	confirmReassignToAgentBtn_clickHandler () {
		const reassignToAgentSettings = Shark.get("reassignToAgentSettings");
		const agentList = Shark.get("agentList");
		const sourceAgent = Utils.safp(agentList, "guid", reassignToAgentSettings.sourceAgentGuid);
		const destinationAgent = Utils.safp(agentList, "guid", reassignToAgentSettings.destinationAgentGuid);

		reassignToAgentSettings.__sourceAgentGuidError = !sourceAgent;
		reassignToAgentSettings.__destinationAgentGuidError = !destinationAgent;

		if (!sourceAgent || !destinationAgent) {
			alert("Devi selezionare entrambi gli agenti");
			Shark.render();
			return;
		}
		
		if (sourceAgent === destinationAgent) {
			alert("Devi selezionare due agenti diversi!");
			reassignToAgentSettings.__sourceAgentGuidError = true;
			reassignToAgentSettings.__destinationAgentGuidError = true;
			Shark.render();
			return;
		}

		const foundContactList = Shark.get("foundContactList");
		const contact = Utils.safp(foundContactList, "guid", reassignToAgentSettings.contactGuid);

		reassignToAgentSettings.__contactNameError = !contact;
		
		console.log({reassignToAgentSettings})

		if (contact && confirm(`Sei sicuro di voler spostare il contatto '${contact.name}' da ${sourceAgent.__fullName} a ${destinationAgent.__fullName}?\n\nNon sarà possibile annullare!!`)) {
			clientManager.reassignContactToAgent(reassignToAgentSettings)
			.then(response => {
				console.log({response});
				
				//alert("Operazione completata")
				let message = "";
				const items = response?.data?.items;

				if (items?.client?.updateResult?.rowCount) {
					message += `Spostato ${items?.client?.updateResult?.rowCount} Clienti<br>`;
				}

				if (items?.report?.updateResult?.rowCount) {
					message += `Spostato ${items?.report?.updateResult?.rowCount} Report<br>`;
				}

				if (items?.siteInfoSheet?.updateResult?.rowCount) {
					message += `Spostato ${items?.siteInfoSheet?.updateResult?.rowCount} Schede Informative<br>`;
				}

				if (items?.quotations?.updateResult) {
					message += `Spostato ${items?.quotations?.updateResult.length} Preventivi<br>`;
				}

				if (items?.constructionSiteCard?.updateResult?.[0]?.rowCount) {
					message += `Spostato ${items?.constructionSiteCard?.updateResult?.[0]?.rowCount} Schede Cantiere<br>`;
				}

				if (items?.constructionSite?.updateResult?.[0]?.rowCount) {
					message += `Spostato ${items?.constructionSite?.updateResult?.[0]?.rowCount} Cantieri<br>`;
				}

				if (items?.notComplianceReport?.updateResult?.[0]?.rowCount) {
					message += `Spostato ${items?.notComplianceReport?.updateResult?.[0]?.rowCount} Rapporti di Non Conformità<br>`;
				}

				if (items?.folders?.updateResult?.[0]?.rowCount) {
					message += `Spostato ${items?.folders?.updateResult?.[0]?.rowCount} Cartelle<br>`;
				}

				informationModalComponent.show({body: message, title: "Operazione completata"});
			});
		}
		else {
			Shark.render();
		}
	}

	init () {
		this.addComponents([informationModalComponent, mainNavComponent]);

		const reassignProspectBranchToLeadSettings = Shark.getInstance("__smart__", {
			visitGuid: "",
			contactName: "",
			leadGuid: "",
			leadName: "",
			sourceAgentGuid: "",
		});
		
		const reassignToAgentSettings = Shark.getInstance("__smart__", {
			contactGuid: "",
			contactName: "",
			destinationAgentGuid: "",
			sourceAgentGuid: "",
			__contactNameError: false,
			__destinationAgentGuidError: false,
			__sourceAgentGuidError: false,
		});

		Shark.set({
			reassignProspectBranchToLeadSettings,
			reassignToAgentSettings,
		});
	}

	searchContacts (reassignToAgentSettings, type = "contact") {
		// const reassignToAgentSettings = Shark.get("reassignToAgentSettings");

		if (type === "prospect") {
			//devo cercare il prospect e valutare se già da lead e bloccare la cosa.
			// if ()
		}

		if (reassignToAgentSettings.sourceAgentGuid.trim() !== "" && (((type === "contact" || type === "prospect") && reassignToAgentSettings.contactName.trim() !== "") || (type === "lead" && reassignToAgentSettings.leadName.trim() !== ""))) {
			reassignToAgentSettings.__contactNameError = false;
			reassignToAgentSettings.__leadNameError = false;
			reassignToAgentSettings.__prospectNameError = false;
			reassignToAgentSettings.__sourceAgentGuidError = false;

			const filters = {
				agentGuid: reassignToAgentSettings.sourceAgentGuid,
				name: type === "lead" ? reassignToAgentSettings.leadName.trim() : reassignToAgentSettings.contactName.trim(),
				showLead: type !== "contact",
				// showLead: type !== "contact",
			};
			const range = {
				first: 0,
				length: 10,
			};
			
			if (type === "contact") {
				return clientManager.getFilteredList({filters, range})
				.then(searchResponse => {
					console.log({searchResponse});
					const foundContactList = searchResponse.data;
					return foundContactList;
				});
			}
			else if (type === "prospect") {
				return visitManager.getFilteredList({filters, range})
				.then(searchResponse => {
					console.log({searchResponse});
					const foundContactList = searchResponse.data;
					return foundContactList;
				});
			}
			else {
				return clientManager.getFilteredLeadList({filters, range})
				.then(searchResponse => {
					console.log({searchResponse});
					const foundContactList = searchResponse.data;
					return foundContactList;
				});
			}
		}
		else {
			reassignToAgentSettings.__sourceAgentGuidError = reassignToAgentSettings.sourceAgentGuid.trim() === "";
			
			if (type === "contact") {
				reassignToAgentSettings.__contactNameError = reassignToAgentSettings.contactName.trim() === "";
				reassignToAgentSettings.__prospectNameError = false;
				reassignToAgentSettings.__leadNameError = false;
			}
			else if (type === "prospect") {
				reassignToAgentSettings.__prospectNameError = reassignToAgentSettings.contactName.trim() === "";
				reassignToAgentSettings.__leadNameError = false;
			}
			else {
				reassignToAgentSettings.__contactNameError = false;
				reassignToAgentSettings.__prospectNameError = false;
				reassignToAgentSettings.__leadNameError = reassignToAgentSettings[`${type}Name`].trim() === "";
			}

			Shark.render();
			return Promise.resolve();
		}
	}

	
	startContactSearchBtn_clickHandler () {
		const reassignToAgentSettings = Shark.get("reassignToAgentSettings");

		this.searchContacts(reassignToAgentSettings)
		.then(response => {
			if (response) {
				Shark.set({
					foundContactList: response,
				});
				Shark.render();
			}
		});
	}
	
	startContactForProspectSearchBtn_clickHandler () {
		const reassignProspectBranchToLeadSettings = Shark.get("reassignProspectBranchToLeadSettings");

		this.searchContacts(reassignProspectBranchToLeadSettings, "prospect")
		.then(response => {
			if (response) {
				Shark.set({
					foundContactListForProspect: response,
				});
				Shark.render();
			}
		});
	}

	startLeadForProspectSearchBtn_clickHandler () {
		const reassignProspectBranchToLeadSettings = Shark.get("reassignProspectBranchToLeadSettings");

		this.searchContacts(reassignProspectBranchToLeadSettings, "lead")
		.then(response => {
			if (response) {
				Shark.set({
					foundLeadListForProspect: response,
				});
				Shark.render();
			}
		});
	}
}

const contactManageView = new ContactManageView();

// contactManageView.addMethod("backToClientListBtn_clickHandler", function () {
// 	Shark.openPage(clientListView);
// });


// contactManageView.addMethod("cancelEditsBtn_clickHandler", function () {
// 	const editingClient = Shark.get("editingClient");

// 	if (!editingClient.isDirty() || (editingClient.isDirty() && confirm("Sei sicuro di voler annullare le modifiche apportate?"))) {
// 		editingClient.restore();

// 		if (Shark.get("isNewClient")) {
// 			Shark.set("isNewClient", false);
// 			Shark.openPage(clientListView);
// 		}
// 		else {
// 			Shark.set("__isEditing", false);
// 			// Shark.render();
// 		}
// 	}
// });

// contactManageView.addMethod("clientSourceField_changeHandler", function () {
// 	const clientSourceField = document.querySelector("#clientSourceField");
// 	const clientFairSourceBox = document.querySelector("#clientFairSourceBox");

// 	if (clientSourceField) {
// 		if (parseInt(clientSourceField.value) === 2) {
// 			clientFairSourceBox.classList.add("d-block");
// 			clientFairSourceBox.classList.remove("d-none");
// 		}
// 		else {
// 			clientFairSourceBox.classList.remove("d-block");
// 			clientFairSourceBox.classList.add("d-none");
// 		}
// 	}
// });

// contactManageView.addMethod("saveClientBtn_clickHandler", function () {
// 	const editingClient = Shark.get("editingClient");
// 	//Dave.ToDo: Spostiamo anche il salvataggio nel componente
// 	const currFollowUp = Shark.get("currFollowUp");

// 	if (currFollowUp) {
// 		if (currFollowUp.isDirty()) {
// 			// editingClient.addFollowUp(currFollowUp);
// 			clientFollowUpManager.save(currFollowUp);
// 		}
// 	}
// 	clientManager.save(editingClient);
// });

// // contactManageView.addMethod("siteInfoSheetManager_listChangedHandler", function () {
// // 	this.set({
// // 		siteInfoSheetList: Shark.get("siteInfoSheetList")
// // 	});
// // });

// contactManageView.addMethod("userManager_listChangedHandler", function () {
// 	this.set({
// 		agentList: Shark.get("agentList")
// 	});
// });

/*
Appunti query per passaggio di TUTTO il materiale di un agente ad un altro agente:
UPDATE `client_visits` SET  `cliv_agent_guid`= '9433936b-93f1-4184-9d21-3a4478a749db'  WHERE cliv_agent_guid= '30c06415-1302-441c-89d4-f4f9702ff801' AND cliv_status <> 9;

UPDATE `site_info_sheets` SET  sis_user_guid = '9433936b-93f1-4184-9d21-3a4478a749db' WHERE sis_user_guid = '30c06415-1302-441c-89d4-f4f9702ff801' AND sis_status <> 9;

UPDATE `folders` SET fold_parent_guid = '885e515d-9758-4b9d-b6a5-747fbe817714' WHERE fold_parent_guid = '46a7a1b0-8985-4ab2-8f80-56ef30999e7b';
UPDATE `folders` SET fold_parent_guid = '451f0d43-d359-4196-9de0-288db007443a' WHERE fold_parent_guid = 'd7be49d3-28fd-4cd4-a5be-bc50cbb78e76';
UPDATE `folders` SET fold_owner_guid = '9433936b-93f1-4184-9d21-3a4478a749db' WHERE fold_owner_guid = '30c06415-1302-441c-89d4-f4f9702ff801' AND fold_guid NOT IN ('46a7a1b0-8985-4ab2-8f80-56ef30999e7b', 'd7be49d3-28fd-4cd4-a5be-bc50cbb78e76');
*/

Shark.registerView(contactManageView);

export default contactManageView;
